import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { format } from 'date-fns';
import _ from 'lodash';

import { shortDateAndTimeFormat, shortDateFormat } from '../utils/datesFormat';

const TableComponent = (props) => {
    const { 
        page,
        rowsPerPage,
        updateState,
        headers,
        fields,
        data,
        onRowClick,
        count,
        type,
        handleEditClick
    } = props;

    const handleChangeRowsPerPage = (event) => {
        updateState(parseInt(event.target.value, 10), "rowsPerPage");
        updateState(0, "page");
    };
    const handleChangePage = (event, newPage) => {
        updateState(newPage, "page");
    };

    const onEditClick = (event, id) => {
        event.stopPropagation();
        handleEditClick(id);
    }

    return (
        <div style={{ width: '98%', padding: 10 }}>
            <TableContainer component={Paper}>
                <Table style={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            {headers.map((header, idx) => (
                                <TableCell key={idx} style={{ fontSize: 16, fontWeight: 'bold' }}>{header}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, rowIdx) => (
                            <TableRow hover key={rowIdx} style={{ cursor: 'pointer' }} onClick={() => onRowClick(row)}>
                                {fields.map((field, idx) => {
                                    let display = _.get(row, field);
                                    // when display is a boolean value, 
                                    // we display 'True' / 'False' accordingly
                                    if (field === 'settings.is_public' || typeof display === 'boolean') {
                                        display = display ? 'True' : 'False';
                                    } else if (field === 'last_updated_at') {
                                        display = format(new Date(display), shortDateAndTimeFormat);
                                    } else if (field === 'lastUpdated') {
                                        display = format(
                                            new Date(display), 
                                            shortDateAndTimeFormat);
                                    } else if (field === 'dateAdded' || field === 'dateArchived') {
                                        display = format(new Date(display.toDate()), shortDateFormat);
                                    }
                                    if (Array.isArray(display)) {
                                        display = returnItems(display);
                                    }
                                    if (idx === 0) {
                                        return (
                                            <TableCell component="th" scope="row" key={idx}> {display} </TableCell>
                                        )
                                    }
                                    return (
                                        <TableCell key={idx}>{display}</TableCell>
                                    )
                                })}
                                {handleEditClick && 
                                <TableCell style={{ borderTop: '1px solid rgba(224, 224, 224, 1)' }} >
                                    <Button 
                                        variant="outlined" 
                                        color="primary" 
                                        onClick={(e) => onEditClick(e, row.id)}
                                    >
                                        Edit
                                    </Button>
                                </TableCell>
                                }
                            </TableRow>
                        )
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                component="div"
                count={count}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={(type === 'surveys') ? [10] : [10, 25, 50, 100]}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </div>
    )
};

function returnItems(arr) {
    return (
        <div>
            {arr.map(item => (
                <p key={item}>{item}</p>
            ))}
        </div>
    )
}

export default TableComponent;